import { checkHttpStatusAuthCheck } from '../../../../../actions/utilAction';
import {
    actionCreator,
    checkHttpStatus, 
    jsonApiHeader, 
    DataCollectionBatchGraphActionTypes, 
    GET_DC_PATIENT_SKILLACQ_BATCHGRAPH_API, 
    GET_DC_PATIENT_BEHAVIOUR_BATCHGRAPH_API,
    GET_TARGETSANDPROGRAMSDATA_API,
    GET_BEHAVIORREDUCTIONSDATA_API
} from '../constants/ApiConstants';

export const getSkillAcquisitionGraphDCAction = (patientId,targetIds,fromDate,toDate,graphType,skillsAcquisitionProgramId) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientSkillAcqBATCHGraphAPI.REQUEST));
        fetch(`${GET_DC_PATIENT_SKILLACQ_BATCHGRAPH_API}?patientId=${patientId}&targetIds=${targetIds}&fromDate=${fromDate}&toDate=${toDate}&skillAcquisitionProgramId=${skillsAcquisitionProgramId}&graphType=${graphType}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientSkillAcqBATCHGraphAPI.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientSkillAcqBATCHGraphAPI.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_DC_PatientSkillAcqBATCHGraphAPI', error);
            });
    };
};

export const getBehaviourGraphDCAction = (patientId,behaviorsReductionIds,fromDate,toDate,recordingTypeName,graphType) => {
    return (dispatch, getState) => {
        dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientBehaviourBATCHGraphAPI.REQUEST));
        fetch(`${GET_DC_PATIENT_BEHAVIOUR_BATCHGRAPH_API}?patientId=${patientId}&behaviorsReductionIds=${behaviorsReductionIds}&fromDate=${fromDate}&toDate=${toDate}&recordingTypeName=${recordingTypeName}&graphType=${graphType}`, {
            method: 'get',
            headers: jsonApiHeader(getState().login.access_token, 'application/json'),
        })
            .then(checkHttpStatus)
            .then(function (response) {
                if (response.statusCode >= 200 && response.statusCode < 300 && response.statusCode !== 204) {
                    dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientBehaviourBATCHGraphAPI.SUCCESS, response));
                } else {
                    dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_DC_PatientBehaviourBATCHGraphAPI.SUCCESS, null));
                }
            }).catch(function (error) {
                console.log('error get_DC_PatientBehaviourBATCHGraphAPI', error);
            });
    };
};

export const getPatientBehaviorsReductionByPatientId = (patientId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_BehaviorsReductionsData.REQUEST));
      fetch(`${GET_BEHAVIORREDUCTIONSDATA_API}?patientId=${patientId}`, {
        method: 'get',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
        .then(function (response) {
          if(response.statusCode === 200)
          dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_BehaviorsReductionsData.SUCCESS, response));
          else 
            dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_BehaviorsReductionsData.SUCCESS, null));
        })
        .catch(function (error) {
          console.log('get master data (soap actions) ..', error);
        });
    };
  };
  

  export const getTargetsAndProgramsData = (patientId) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_TargetsAndProgramsData.REQUEST));
      fetch(`${GET_TARGETSANDPROGRAMSDATA_API}?patientId=${patientId}`, {
        method: 'get',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
      .then((res)=>checkHttpStatusAuthCheck(res,dispatch,getState))
        .then(function (response) {
          if(response.statusCode === 200)
          dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_TargetsAndProgramsData.SUCCESS, response));
          else 
            dispatch(actionCreator(DataCollectionBatchGraphActionTypes.get_TargetsAndProgramsData.SUCCESS, null));
        })
        .catch(function (error) {
          console.log('get master data (soap actions) ..', error);
        });
    };
  };

  export const setGraphAnnotationAndBaselineBlank = () => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.set_GraphAnnotationAndBaselineBlank.SUCCESS));
    };
  };

  export const setGraphAnnotationValue = (AnnotationLabel) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.set_GraphAnnotationValue.REQUEST));
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.set_GraphAnnotationValue.SUCCESS, AnnotationLabel));
    };
  };

  export const setGraphBaselineValue = (BaselineLabel) => {
    return (dispatch, getState) => {
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.set_GraphBaselineValue.REQUEST));
      dispatch(actionCreator(DataCollectionBatchGraphActionTypes.set_GraphBaselineValue.SUCCESS, BaselineLabel));
    };
  };


// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollectionBatchGraph/actions/index.js